export const PREVIEW_HOSTNAMES = new Set<string | null>([
  // Code.org
  'preview-code.marketing-sites.code.org',
  'preview-code.marketing-sites.dev-code.org',
  'preview-code.marketing-sites.test-code.org',
  'preview-code.marketing-sites.localhost:3001',
  // CS For All
  'preview-csforall.marketing-sites.code.org',
  'preview-csforall.marketing-sites.dev-code.org',
  'preview-csforall.marketing-sites.test-code.org',
  'preview-csforall.marketing-sites.localhost:3001',
  // AIDay
  'preview-aiday.marketing-sites.code.org',
  'preview-aiday.marketing-sites.dev-code.org',
  'preview-aiday.marketing-sites.test-code.org',
  'preview-aiday.marketing-sites.localhost:3001',
  // Hour of AI
  'preview-hourofai.marketing-sites.code.org',
  'preview-hourofai.marketing-sites.dev-code.org',
  'preview-hourofai.marketing-sites.test-code.org',
  'preview-hourofai.marketing-sites.localhost:3001',
]);
